import { PatientData } from "@/modules/patients/detail/store/usePatientStore"
import { ArrElement } from "@/types/ArrElement"

type InsureeList = NonNullable<PatientData>["insurees"]
type Coverages = ArrElement<InsureeList>["coverages"]
type Insuree = ArrElement<InsureeList> & {
  coverage: ArrElement<Coverages> | undefined
}

const getCoverage = (coverages: Coverages | undefined, isPrimary = true): ArrElement<Coverages> | undefined => {
  if (!coverages) return undefined
  return coverages.find((item) => item.product.isPrimary === isPrimary)
}

export const getInsureeInfo = (insurees: InsureeList | undefined, isPrimary = true): Insuree | undefined => {
  if (!insurees) return undefined

  const primaryInsuree = insurees.find((item) => getCoverage(item.coverages, isPrimary))

  if (primaryInsuree) {
    return {
      ...primaryInsuree,
      coverage: getCoverage(primaryInsuree.coverages, isPrimary),
    }
  }
  return undefined
}
